import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function UsersTable({ rows, onConfigureUser, typesUser }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <TableHeader />
          <tbody className={classes.tableBody}>
            {rows &&
              rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.userId}
                  item={item}
                  onConfigureUser={onConfigureUser}
                  typesUser={typesUser}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default UsersTable
